import { createContext } from 'react';
import EditSplashContext from 'types/contexts/EditSplashContext';

export default createContext({} as EditSplashContext);
